import { jsxs as j, jsx as g } from "react/jsx-runtime";
import * as v from "react";
import { forwardRef as y, useRef as x, useState as O, useImperativeHandle as D, useEffect as P } from "react";
import { c as S } from "./index.js-Cr0Rsuyz.mjs";
import { e as q } from "./extract-responsive-property-BiJ5BiwI.mjs";
import { c as z } from "./tw-cn-mXgPecoF.mjs";
import { c as C } from "./variance-DhhqoHkK.mjs";
function A(e, a) {
  return /* @__PURE__ */ v.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: a
  }, e), /* @__PURE__ */ v.createElement("path", {
    fill: "currentColor",
    d: "M20.116 6.116a1.25 1.25 0 1 1 1.768 1.768l-11 11a1.25 1.25 0 0 1-1.768 0l-6-6a1.25 1.25 0 1 1 1.768-1.768L10 16.232z"
  }));
}
var F = S(/* @__PURE__ */ y(A));
function K(e, a) {
  return /* @__PURE__ */ v.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: a
  }, e), /* @__PURE__ */ v.createElement("path", {
    fill: "currentColor",
    d: "M4 13.25a1.25 1.25 0 1 1 0-2.5h16a1.25 1.25 0 1 1 0 2.5z"
  }));
}
var B = S(/* @__PURE__ */ y(K));
const H = C(["relative inline-block"], {
  variants: {
    size: {
      medium: "size-24",
      small: "size-20"
    },
    pcSize: {
      medium: "pc:size-24",
      small: "pc:size-20"
    }
  }
}), T = C(
  [
    "focus:ring-green-500 peer size-full appearance-none rounded-4 cursor-pointer",
    "bg-static-white border border-line-neutral-medium",
    "checked:border-none disabled:cursor-not-allowed"
  ],
  {
    variants: {
      state: {
        checked: [
          "checked:bg-fill-primary-main checked:hover-never:bg-interaction-primary-presshover-strong3 checked:active:bg-interaction-primary-presshover-strong3",
          "disabled:bg-interaction-neutral-disable-main disabled:hover-never:bg-interaction-neutral-disable-main disabled:active:bg-interaction-neutral-disable-main"
        ],
        empty: [
          "checked:bg-fill-primary-main hover-never:bg-interaction-neutral-presshover-weak1 checked:active:bg-interaction-neutral-presshover-weak1",
          "disabled:bg-fill-neutral-weak disabled:hover:bg-fill-neutral-weak disabled:border-interaction-neutral-disable-main"
        ],
        indeterminate: [
          "bg-fill-primary-main border-none hover-never:bg-interaction-primary-presshover-strong3 active:bg-interaction-primary-presshover-strong3",
          "disabled:bg-interaction-neutral-disable-main disabled:hover-never:bg-interaction-neutral-disable-main disabled:active:bg-interaction-neutral-disable-main"
        ]
      }
    },
    defaultVariants: {
      state: "empty"
    }
  }
), E = C(
  ["pointer-events-none absolute text-static-white", "left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"],
  {
    variants: {
      state: {
        default: "opacity-0 peer-checked:opacity-100",
        indeterminate: ""
      },
      size: {
        medium: "size-20",
        small: "size-16"
      },
      pcSize: {
        medium: "pc:size-20",
        small: "pc:size-16"
      }
    },
    defaultVariants: {
      state: "default"
    }
  }
), c = {
  Checked: "checked",
  Indeterminate: "indeterminate",
  Empty: "empty"
}, V = y((e, a) => {
  const {
    className: t,
    style: l,
    checked: r,
    indeterminate: n,
    disabled: m,
    type: u = "checkbox",
    size: h,
    onChange: i,
    ...p
  } = e, o = x(null), d = x(null), [f, b] = O(() => n ? c.Indeterminate : r ? c.Checked : c.Empty), k = q({
    property: h,
    mobileKey: "size",
    pcKey: "pcSize",
    defaultValue: {
      mobile: "small",
      pc: "medium"
    }
  }), w = H({ ...k }), R = T({ state: f });
  D(a, () => ({
    focus: (s) => {
      var I;
      (I = o.current) == null || I.focus(s);
    },
    blur: () => {
      var s;
      (s = o.current) == null || s.blur();
    },
    input: o.current,
    nativeElement: d.current
  }));
  const N = (s) => {
    m || (b(s.target.checked ? c.Checked : c.Empty), i == null || i({
      target: {
        ...e,
        type: u,
        checked: s.target.checked
      },
      stopPropagation() {
        s.stopPropagation();
      },
      preventDefault() {
        s.preventDefault();
      },
      nativeEvent: s.nativeEvent
    }));
  };
  return P(() => {
    b(n ? c.Indeterminate : r ? c.Checked : c.Empty);
  }, [r, n]), /* @__PURE__ */ j("span", { className: z(w, t), ref: d, style: l, children: [
    /* @__PURE__ */ g(
      "input",
      {
        ...p,
        checked: f === c.Checked,
        className: z(R, w),
        disabled: m,
        onChange: N,
        ref: o,
        type: u
      }
    ),
    f === c.Checked && /* @__PURE__ */ g(F, { className: E({ ...k }) }),
    f === c.Indeterminate && /* @__PURE__ */ g(B, { className: E({ ...k, state: "indeterminate" }) })
  ] });
});
V.displayName = "NDS.Checkbox";
const G = (e, a, t, l) => {
  const r = { ...e }, n = (m, u, h) => {
    Object.values(r).forEach((i) => {
      i.parentId === m && (r[i.id] = { ...i, checked: u, indeterminate: h }, i.hasChildren && n(i.id, u, h));
    });
  };
  return n(a, t, l), r;
}, L = (e, a) => {
  const t = { ...e }, l = (r) => {
    const n = t[r];
    if (!n.parentId)
      return;
    const m = t[n.parentId], u = Object.values(t).filter((d) => d.parentId === n.parentId), h = u.every((d) => d.checked), i = u.every((d) => !d.checked && !d.indeterminate);
    let p = !1, o = !1;
    h ? (p = !0, o = !1) : i ? (p = !1, o = !1) : (p = !1, o = !0), t[m.id] = { ...m, checked: p, indeterminate: o }, l(m.id);
  };
  return l(a), t;
}, Q = (e, a) => {
  switch (a.type) {
    case "TOGGLE_CHECKED": {
      const t = e[a.id];
      if (!t) return e;
      const l = {
        ...e,
        [a.id]: { ...t, checked: !t.checked, indeterminate: !1 }
      }, r = l[a.id];
      let n = l;
      return r.hasChildren && (n = G(n, r.id, r.checked, r.indeterminate)), r.parentId && (n = L(n, r.id)), n;
    }
    default:
      return e;
  }
}, Y = (e) => Object.values(e).filter((t) => t.type === "required").every((t) => t.checked);
export {
  V as C,
  Y as i,
  Q as n
};
